export const REBUZZ_OPTIONS = {
  CONTENT: 'content',
  PROMOTION: 'promotion',
  ENDORSEMENT: 'endorsement',
};
